


















import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import { IFraudMindProviderMethods } from "@/models/providers/fraud";

@Component
export default class FraudCheckDataModal extends Vue {
  // Inject
  @Inject({ from: "fraudMindProviderMethods" })
  public $fraudMethods!: IFraudMindProviderMethods;

  // Props
  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  // Data
  public data: any = {};
  public isLoading = true;
  public isReloading = true;
  public hasRequestError = false;

  public created() {
    this.loadData({ ignoreStored: false });
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData({ ignoreStored: true });
  }

  public async loadData({ ignoreStored = false }) {
    try {
      const res = await this.$fraudMethods.getInvoiceFraudCheckData({
        invoiceId: this.invoiceId,
        ignoreStored
      });
      this.data = res?.fraud_check_data || {};
      this.hasRequestError = false;
    } catch (error) {
      this.hasRequestError = true;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }
}
